import type { Group } from 'types/group'
import type { PublicPlaylist } from 'types/public-playlist'
import type { RootGroup } from 'types/shareable-channel'
import * as types from './types'
export const updateSearchQuery = (
  query: string,
): {
  query: string
  type: 'PUBLIC_SEARCH_UPDATE_QUERY'
} => ({
  type: types.PUBLIC_SEARCH_UPDATE_QUERY,
  query: query,
})
export const publicSearch = (
  q: string,
  group: Group | RootGroup,
  playlist?: PublicPlaylist,
): {
  group: Group | RootGroup
  playlist: void | PublicPlaylist
  q: string
  type: 'PUBLIC_SEARCH'
} => ({
  type: types.PUBLIC_SEARCH,
  q,
  group,
  playlist,
})
export const publicSearchSuccess = (
  q: string,
  group: Group | RootGroup,
  playlist: PublicPlaylist | undefined,
  response: any,
): {
  group: Group | RootGroup
  playlist: void | PublicPlaylist
  q: string
  response: any
  type: 'PUBLIC_SEARCH_SUCCESS'
} => ({
  type: types.PUBLIC_SEARCH_SUCCESS,
  q,
  group,
  playlist,
  response,
})
export const publicSearchFail = (
  q: string,
  group: Group | RootGroup,
  playlist: PublicPlaylist | undefined,
  error: Error,
): {
  error: Error
  group: Group | RootGroup
  playlist: void | PublicPlaylist
  q: string
  type: 'PUBLIC_SEARCH_FAIL'
} => ({
  type: types.PUBLIC_SEARCH_FAIL,
  q,
  group,
  playlist,
  error,
})
export const resetSearch = (): {
  type: 'PUBLIC_SEARCH_RESET'
} => ({
  type: types.PUBLIC_SEARCH_RESET,
})
export const publicSearchNext = (): {
  type: string
} => ({
  type: types.PUBLIC_SEARCH_NEXT,
})
export const publicSearchNextSuccess = (
  response: any,
): {
  response: any
  type: string
} => ({
  type: types.PUBLIC_SEARCH_NEXT_SUCCESS,
  response,
})
export const publicSearchNextFail = (
  error: Error,
): {
  error: Error
  type: string
} => ({
  type: types.PUBLIC_SEARCH_NEXT_FAIL,
  error,
})
